import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  // loadingExcel: false,
  reporteLoginLength: 0,
  // reporteLoginExcelLength: 0,
  reporteLogin: [],
  // reporteLoginExcel: [],
}

export default function ReporteLoginReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_REPORTE_LOGIN:
      return {...state, loading: action.payload}
    case actions.LOADING_REPORTE_LOGIN_EXCEL:
      return {...state, loadingExcel: action.payload}
    case actions.GET_REPORTE_LOGIN:
      return {...state, reporteLogin: action.payload.reporteLogin, reporteLoginLength: action.payload.reporteLoginLength}
    case actions.GET_REPORTE_LOGIN_EXCEL:
      return {...state, reporteLoginExcel: action.payload.reporteLoginExcel, reporteLoginExcelLength: action.payload.reporteLoginExcelLength}
    default:
      return {...state};
  }
}